"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerInfoT = exports.TrackerInfo = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const body_part_js_1 = require("../../../solarxr-protocol/datatypes/body-part.js");
const hz_f32_js_1 = require("../../../solarxr-protocol/datatypes/hz-f32.js");
const magnetometer_status_js_1 = require("../../../solarxr-protocol/datatypes/magnetometer-status.js");
const imu_type_js_1 = require("../../../solarxr-protocol/datatypes/hardware-info/imu-type.js");
const tracker_data_type_js_1 = require("../../../solarxr-protocol/datatypes/hardware-info/tracker-data-type.js");
const quat_js_1 = require("../../../solarxr-protocol/datatypes/math/quat.js");
/**
 * Static description of a tracker
 */
class TrackerInfo {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackerInfo(bb, obj) {
        return (obj || new TrackerInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackerInfo(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackerInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    imuType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : imu_type_js_1.ImuType.Other;
    }
    /**
     * The user-assigned role of the tracker.
     */
    bodyPart() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : body_part_js_1.BodyPart.NONE;
    }
    /**
     * average samples per second
     */
    pollRate(obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new hz_f32_js_1.HzF32()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * The orientation of the tracker when mounted on the body
     */
    mountingOrientation(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new quat_js_1.Quat()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Should the tracker's settings be editable by the user
     */
    editable() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    /**
     * Indicates if the tracker is computed (solved position and rotation)
     */
    isComputed() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    /**
     * Indicates if the tracker is using an IMU for its tracking data
     */
    isImu() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    displayName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    customName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    /**
     * Whether to allow yaw drift compensation for this tracker or not.
     */
    allowDriftCompensation() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    /**
     * Mounting Reset orientation overrides the current `mounting_orientation` of
     * the tracker, this orientation is not saved and needs to be calculated
     * each time the server is ran
     */
    mountingResetOrientation(obj) {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? (obj || new quat_js_1.Quat()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Indicates if the tracker is actually an HMD
     */
    isHmd() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    magnetometer() {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : magnetometer_status_js_1.MagnetometerStatus.NOT_SUPPORTED;
    }
    /**
     * Indicates what type of data the tracker sends (note: it always ends up being rotation in the end)
     */
    dataSupport() {
        const offset = this.bb.__offset(this.bb_pos, 30);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : tracker_data_type_js_1.TrackerDataType.ROTATION;
    }
    static startTrackerInfo(builder) {
        builder.startObject(14);
    }
    static addImuType(builder, imuType) {
        builder.addFieldInt16(0, imuType, imu_type_js_1.ImuType.Other);
    }
    static addBodyPart(builder, bodyPart) {
        builder.addFieldInt8(1, bodyPart, body_part_js_1.BodyPart.NONE);
    }
    static addPollRate(builder, pollRateOffset) {
        builder.addFieldStruct(2, pollRateOffset, 0);
    }
    static addMountingOrientation(builder, mountingOrientationOffset) {
        builder.addFieldStruct(3, mountingOrientationOffset, 0);
    }
    static addEditable(builder, editable) {
        builder.addFieldInt8(4, +editable, +false);
    }
    static addIsComputed(builder, isComputed) {
        builder.addFieldInt8(5, +isComputed, +false);
    }
    static addIsImu(builder, isImu) {
        builder.addFieldInt8(6, +isImu, +false);
    }
    static addDisplayName(builder, displayNameOffset) {
        builder.addFieldOffset(7, displayNameOffset, 0);
    }
    static addCustomName(builder, customNameOffset) {
        builder.addFieldOffset(8, customNameOffset, 0);
    }
    static addAllowDriftCompensation(builder, allowDriftCompensation) {
        builder.addFieldInt8(9, +allowDriftCompensation, +false);
    }
    static addMountingResetOrientation(builder, mountingResetOrientationOffset) {
        builder.addFieldStruct(10, mountingResetOrientationOffset, 0);
    }
    static addIsHmd(builder, isHmd) {
        builder.addFieldInt8(11, +isHmd, +false);
    }
    static addMagnetometer(builder, magnetometer) {
        builder.addFieldInt8(12, magnetometer, magnetometer_status_js_1.MagnetometerStatus.NOT_SUPPORTED);
    }
    static addDataSupport(builder, dataSupport) {
        builder.addFieldInt8(13, dataSupport, tracker_data_type_js_1.TrackerDataType.ROTATION);
    }
    static endTrackerInfo(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new TrackerInfoT(this.imuType(), this.bodyPart(), (this.pollRate() !== null ? this.pollRate().unpack() : null), (this.mountingOrientation() !== null ? this.mountingOrientation().unpack() : null), this.editable(), this.isComputed(), this.isImu(), this.displayName(), this.customName(), this.allowDriftCompensation(), (this.mountingResetOrientation() !== null ? this.mountingResetOrientation().unpack() : null), this.isHmd(), this.magnetometer(), this.dataSupport());
    }
    unpackTo(_o) {
        _o.imuType = this.imuType();
        _o.bodyPart = this.bodyPart();
        _o.pollRate = (this.pollRate() !== null ? this.pollRate().unpack() : null);
        _o.mountingOrientation = (this.mountingOrientation() !== null ? this.mountingOrientation().unpack() : null);
        _o.editable = this.editable();
        _o.isComputed = this.isComputed();
        _o.isImu = this.isImu();
        _o.displayName = this.displayName();
        _o.customName = this.customName();
        _o.allowDriftCompensation = this.allowDriftCompensation();
        _o.mountingResetOrientation = (this.mountingResetOrientation() !== null ? this.mountingResetOrientation().unpack() : null);
        _o.isHmd = this.isHmd();
        _o.magnetometer = this.magnetometer();
        _o.dataSupport = this.dataSupport();
    }
}
exports.TrackerInfo = TrackerInfo;
class TrackerInfoT {
    constructor(imuType = imu_type_js_1.ImuType.Other, bodyPart = body_part_js_1.BodyPart.NONE, pollRate = null, mountingOrientation = null, editable = false, isComputed = false, isImu = false, displayName = null, customName = null, allowDriftCompensation = false, mountingResetOrientation = null, isHmd = false, magnetometer = magnetometer_status_js_1.MagnetometerStatus.NOT_SUPPORTED, dataSupport = tracker_data_type_js_1.TrackerDataType.ROTATION) {
        this.imuType = imuType;
        this.bodyPart = bodyPart;
        this.pollRate = pollRate;
        this.mountingOrientation = mountingOrientation;
        this.editable = editable;
        this.isComputed = isComputed;
        this.isImu = isImu;
        this.displayName = displayName;
        this.customName = customName;
        this.allowDriftCompensation = allowDriftCompensation;
        this.mountingResetOrientation = mountingResetOrientation;
        this.isHmd = isHmd;
        this.magnetometer = magnetometer;
        this.dataSupport = dataSupport;
    }
    pack(builder) {
        const displayName = (this.displayName !== null ? builder.createString(this.displayName) : 0);
        const customName = (this.customName !== null ? builder.createString(this.customName) : 0);
        TrackerInfo.startTrackerInfo(builder);
        TrackerInfo.addImuType(builder, this.imuType);
        TrackerInfo.addBodyPart(builder, this.bodyPart);
        TrackerInfo.addPollRate(builder, (this.pollRate !== null ? this.pollRate.pack(builder) : 0));
        TrackerInfo.addMountingOrientation(builder, (this.mountingOrientation !== null ? this.mountingOrientation.pack(builder) : 0));
        TrackerInfo.addEditable(builder, this.editable);
        TrackerInfo.addIsComputed(builder, this.isComputed);
        TrackerInfo.addIsImu(builder, this.isImu);
        TrackerInfo.addDisplayName(builder, displayName);
        TrackerInfo.addCustomName(builder, customName);
        TrackerInfo.addAllowDriftCompensation(builder, this.allowDriftCompensation);
        TrackerInfo.addMountingResetOrientation(builder, (this.mountingResetOrientation !== null ? this.mountingResetOrientation.pack(builder) : 0));
        TrackerInfo.addIsHmd(builder, this.isHmd);
        TrackerInfo.addMagnetometer(builder, this.magnetometer);
        TrackerInfo.addDataSupport(builder, this.dataSupport);
        return TrackerInfo.endTrackerInfo(builder);
    }
}
exports.TrackerInfoT = TrackerInfoT;
